import { Select } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { Priority } from "../../../../utils/backend-types";
import { PRIORITIES } from "../../Todos.constants";
import type { TodoTableTodo } from "../TodoTable";

function getPriorityColumn(
  onChangePriority: (priorityValue: Priority, id: number) => void
): MRT_ColumnDef<TodoTableTodo> {
  return {
    header: "Priorität",
    accessorKey: "priority",
    size: 140,
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: Object.keys(PRIORITIES).map((key) => ({
        value: PRIORITIES[key].value,
        label: PRIORITIES[key].displayName
      }))
    },
    sortingFn: (rowA, rowB) => {
      const priorities = Object.keys(PRIORITIES).map(
        (key) => PRIORITIES[key].value
      );
      const priorityA = priorities.indexOf(rowA.original.priority);
      const priorityB = priorities.indexOf(rowB.original.priority);
      return priorityA - priorityB;
    },
    Cell: ({ row }) => (
      <Select
        data={Object.keys(PRIORITIES).map((key) => ({
          value: PRIORITIES[key].value,
          label: PRIORITIES[key].displayName
        }))}
        value={row.original.priority}
        onChange={(newPriority) =>
          onChangePriority(newPriority as Priority, row.original.id)
        }
      />
    )
  };
}

export { getPriorityColumn };
